import moment from 'moment'
import Api from '@/api/Api'

export const state = {
  tickets: [],
  unreadMessageCount: 0
}

export const getters = {
  tickets: (state) => state.tickets.map(ticket => ({
    ...ticket,
    time: moment.parseZone(ticket.created_at).local().format('MM-DD-YY')
  })),
  unreadMessageCount: (state) => state.unreadMessageCount
}

export const mutations = {
  SET_TICKETS: (state, payload) => {
    state.tickets = payload
  },
  SET_UNREAD_MESSAGE_COUNT: (state, payload) => {
    state.unreadMessageCount = payload
  }
}
export const actions = {
  fetchTickets: async ({commit}) => {
    const { data } = await Api.getTickets()
    commit('SET_TICKETS', data.data)
  },
  removeTicket: async ({commit, dispatch}, payload) => {
    await Api.deleteTicket(payload)
    dispatch('fetchTickets')
  },
  disposeTickets: ({commit}) => {
    commit('SET_TICKETS', [])
  },
  getUnreadMessageCount: async ({commit}) => {
    const { data } = await Api.getMessages({
      page: 1,
      perPage: 1
    })
    commit('SET_UNREAD_MESSAGE_COUNT', data.data.unread_message_total)
  },
  incrementUnreadMessageCount: async ({commit, state}) => {
    commit('SET_UNREAD_MESSAGE_COUNT', state.unreadMessageCount + 1)
  },
  resetUnreadMessageCount: async ({commit}) => {
    commit('SET_UNREAD_MESSAGE_COUNT', 0)
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/ticket.js